// extracted by mini-css-extract-plugin
module.exports = {"content-meta":"content-meta","bm-icon":"bm-icon","content-location":"content-location","icon":"icon"};